// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"b9b17af4","612":"637aaf49"}[chunkId] + ".chunk.js";
};